
import * as React from "react";
import { useIsMobile } from "./use-mobile";

type Platform = "web" | "ios" | "android" | "mobile";

export function usePlatform() {
  const isMobile = useIsMobile();
  const [platform, setPlatform] = React.useState<Platform>("web");
  
  React.useEffect(() => {
    // Check if we're running inside Capacitor
    const isCapacitor = window.location.href.includes("capacitor://");
    
    // Determine platform
    if (isCapacitor) {
      if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
        setPlatform("ios");
      } else if (/Android/.test(navigator.userAgent)) {
        setPlatform("android");
      } else {
        setPlatform("mobile");
      }
    } else if (isMobile) {
      setPlatform("mobile");
    } else {
      setPlatform("web");
    }
  }, [isMobile]);
  
  return {
    platform,
    isNative: platform === "ios" || platform === "android",
    isIOS: platform === "ios",
    isAndroid: platform === "android",
    isMobileWeb: platform === "mobile",
    isWeb: platform === "web"
  };
}
